import { widont } from 'utils/typography';
import style from './PageIntroText.module.scss';

export type PageIntroTextType = {
  html: string;
};
export const PageIntroText = ({ html }: PageIntroTextType): JSX.Element | null => {
  if (!html) return null
  return <div className={style.text} dangerouslySetInnerHTML={{ __html: widont(html) }}></div>;
};
